import React from "react";
import classes from "./styles.module.scss";

/**
 * Shared button.
 *
 * Call sites across the app pass presentational overrides (`backgroundColor`,
 * `width`, …) as individual props, so those are still honoured and applied
 * inline. What changed is the baseline: sizing, radius, weight, hover and
 * focus now come from the design system instead of each call site.
 *
 * Prefer `variant="primary" | "secondary" | "danger" | "ghost"` for new code.
 */
const PrimaryButton = ({
    buttonText,
    width,
    height,
    backgroundColor,
    color,
    padding,
    marginTop,
    margin,
    fontSize,
    border,
    icon,
    icon_two,
    fontWight,
    float,
    variant = "primary",
    ...props
}) => {
    const variantClass = classes[variant] || classes.primary;

    return (
        <button
            className={`${classes.button} ${variantClass}`}
            {...props}
            style={{
                width,
                height,
                backgroundColor,
                color,
                marginTop,
                margin,
                fontSize,
                border,
                padding,
                fontWeight: fontWight,
                float,
            }}
        >
            {icon}
            {icon_two}
            {buttonText}
        </button>
    );
};

export default PrimaryButton;
